import { render } from "./WorkSchedules.vue?vue&type=template&id=480b1be1&scoped=true"
import script from "./WorkSchedules.vue?vue&type=script&lang=js"
export * from "./WorkSchedules.vue?vue&type=script&lang=js"

import "./WorkSchedules.vue?vue&type=style&index=0&id=480b1be1&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480b1be1"]])

export default __exports__